import { Chip } from "@mui/material";
import { JobDataStatus, JobStatus } from "types/common-types";

type ChipColor = "default" | "info" | "success" | "warning" | "error";

const statusColor = (status?: string): ChipColor => {
  switch (status) {
    case JobStatus.Processed:
      return "success";
    case JobStatus.Error:
      return "error";
    case JobStatus.ProcessedWithErrors:
    case JobDataStatus.Retrying:
      return "warning";
    case JobStatus.Processing:
    case JobDataStatus.Queued:
      return "info";
    default:
      return "default";
  }
};

export default function ImportStatusChip({
  status,
}: Readonly<{ status?: string }>) {
  if (!status) {
    return null;
  }

  return <Chip label={status} size="small" color={statusColor(status)} />;
}
